/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest } from '../../../api/api'; // eslint-disable-next-line
import config from '../../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
// eslint-disable-next-line
import FormGroupInput from '../../../common/FormGroupInput';
// eslint-disable-next-line
import { Row, Col, Button, Form } from 'react-bootstrap';
// eslint-disable-next-line
import CopiriLoader from '../../../common/CopiriLoader';
import image_loader from '../../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const RitualField = props => {
	// eslint-disable-next-line
	const { lodgeData, id, closeModal, updateLodgeModal, pageLanguageContent } = props; // eslint-disable-next-line
	const [checkDataChange, setCheckDataChange] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [showHideLoader, setShowHideLoader] = useState(false);
	const [showHideTextBox, setShowHideTextBox] = useState(false);
	const [ritualData, setRitualData] = useState([]);
	const [inputField, setInputField] = useState({
		ritual: ''
	});

	const [validation, setValidation] = useState({
		error_ritual: ''
	});
	useEffect(() => {
		getDorpDownData();
		if (props.id) {
			const { ritual } = lodgeData;
			if (ritual !== 'Ritual not provided.') setInputField({ ...inputField, ritual });
		}
		// eslint-disable-next-line
	}, [props.id]);

	const inputsHandler = e => {
		setCheckDataChange(true);
		if (e.target.value === 'other_ritual') {
			setShowHideTextBox(true);
			setInputField({ ...inputField, [e.target.name]: '' });
		} else {
			setInputField({ ...inputField, [e.target.name]: e.target.value });
		}
	};

	function getDorpDownData() {
		setShowHideLoader(true);
		setRitualData([]);
		copiriPortalRequest('/canon/additionalinfo/ritual', config.app_version, 'get')
			.then(response => {
				setShowHideLoader(false);
				if (response.data.values.length > 0) {
					setRitualData(response.data.values);
				}
			})
			.catch(error => {
				setShowHideLoader(false);
			});
	}

	function updateData() {
		let errors = { ...validation };
		var errorCount = 0;

		if (!inputField.ritual.trim()) {
			errors.error_ritual = pageLanguageContent['CLD071'];
			errorCount++;
		} else {
			errors.error_ritual = '';
		}
		var sendData = {};
		sendData['value'] = inputField['ritual'];
		sendData['type'] = 'Ritual';

		setValidation(errors);
		if (errorCount <= 0) {
			setShowLoader(true);
			copiriPortalRequest('/organizations/' + id + '/additional-info', config.app_version, 'patch', sendData)
				.then(response => {
					setShowLoader(false);
					if (response.data.status && response.data.status === 'SUCCESS') {
						toast.success(pageLanguageContent['CLD119']);
						closeModal();
						updateLodgeModal('ritual', inputField['ritual']);
					}
				})
				.catch(error => {
					toast.error(error.response.data.result);
					setShowLoader(false);
				});
		}
	}

	return (
		<>
			{showHideLoader ? (
				<CopiriLoader />
			) : (
				<Row className='mt-2'>
					<Col lg={12}>
						{showHideTextBox ? (
							<FormGroupInput
								id='ritual'
								label={pageLanguageContent['CLD031'] ? pageLanguageContent['CLD031'] : ''}
								placeholder={pageLanguageContent['CLD172'] ? pageLanguageContent['CLD172'] : ''}
								type='text'
								name='ritual'
								onChange={inputsHandler}
								value={inputField.ritual}
							/>
						) : (
							<Form.Group className='form-group'>
								<Form.Label for='ritual'>
									{pageLanguageContent['CLD031'] ? pageLanguageContent['CLD031'] : ''}
								</Form.Label>
								<select
									className='form-control'
									id='ritual'
									type='text'
									name='ritual'
									onChange={inputsHandler}
									value={inputField.ritual}
								>
									<option value=''>{pageLanguageContent['CLD187'] ? pageLanguageContent['CLD187'] : ''}</option>
									{ritualData.length > 0 &&
										ritualData.map((item, i) => (
											<option value={item} key={i}>
												{item}
											</option>
										))}
									<option value='other_ritual'>
										{pageLanguageContent['CLD188'] ? pageLanguageContent['CLD188'] : ''}
									</option>
								</select>
							</Form.Group>
						)}
						{validation.error_ritual && <p className='formValidationError'>{validation.error_ritual}</p>}
					</Col>
					<Col lg={12}>
						<Button
							variant='primary'
							id={'confirmValidatebutton'}
							style={{ float: 'right', marginBottom: '15px' }}
							onClick={updateData}
						>
							{showLoader ? (
								<img src={image_loader} alt='loader' height='20' width='20' />
							) : pageLanguageContent['CLD124'] ? (
								pageLanguageContent['CLD124']
							) : (
								''
							)}
						</Button>
					</Col>
				</Row>
			)}
		</>
	);
};
export default RitualField;
